<template>
  <div>
    <h4 v-if="this.taskDefinition._id">Prozess-Schritt bearbeiten</h4>
    <h4 v-if="!this.taskDefinition._id">Prozess-Schritt erstellen</h4>
    <div
      role="alert"
      class="c-alert c-alert--success"
      style="margin: 2rem 0;"
      v-if="showSuccess"
    >
      Prozess-Schritt gespeichert
    </div>

    <div
      role="alert"
      class="c-alert c-alert--warning"
      style="margin: 2rem 0;"
      v-if="showError"
    >
      Fehler beim Speichern des Prozess-Schritt
    </div>

    <bos-input
      label="Anzeigename (de):"
      :required="true"
      v-model="taskDefinition.displayNameDe"
      :error="errors.displayNameDe"
    />
    <bos-input
      label="Anzeigename (fr):"
      :required="true"
      v-model="taskDefinition.displayNameFr"
      :error="errors.displayNameFr"
    />
    <bos-input
      label="Anzeigename (en):"
      :required="true"
      v-model="taskDefinition.displayNameEn"
      :error="errors.displayNameEn"
    />
    <bos-input
      label="Leistungsgruppe:"
      :required="true"
      v-model="taskDefinition.serviceGroup"
      :error="errors.serviceGroup"
    />
    <bos-input
      type="radios"
      label="Deep-Link manuell erfassen:"
      v-model="taskDefinition.deeplinkmode"
      :options="[
              {'value':'servicegroup','text':'Nach Leistungsgruppe'},
              {'value':'manual','text':'Manuell'},
              {'value':'katalog','text':'KATALOG'},
              {'value':'fileupload','text':'FILEUPLOAD'},
            ]"
    />
    <bos-button
      v-if="!this.taskDefinition._id"
      @click="createTaskDefinition"
      small
    >
      Erstellen
    </bos-button>
    <bos-button
      small
      v-if="this.taskDefinition._id"
      @click="updateTaskDefinition"
    >
      Aktualisieren
    </bos-button>
  </div>
</template>

<script>
import BosButton from '@/components/BosButton'
import BosInput from '@/components/BosInput'
import ApiService from '@/services/ApiService'
import easyScroll from 'easy-scroll'
import FormValidator from '@/services/FormValidator'

export default {
  name: 'AdminTaskDefinitionForm',
  components: { BosInput, BosButton },
  data() {
    return {
      showError: false,
      showSuccess: false,
      taskDefinition: {},
      errors: {
        displayNameDe: {
          hasError: false
        },
        displayNameFr: {
          hasError: false
        },
        displayNameEn: {
          hasError: false
        },
        serviceGroup: {
          hasError: false
        }
      }
    }
  },
  methods: {
    scrollUp() {
      easyScroll({
        scrollableDomEle: window,
        direction: 'top',
        duration: 1250,
        easingPreset: 'easeInOutQuad',
        scrollAmount: window.scrollY
      })
    },
    getTaskDefinitionValidationRules() {
      return [
        {
          value: this.taskDefinition.displayNameDe,
          required: true,
          errorKey: 'displayNameDe'
        },
        {
          value: this.taskDefinition.displayNameFr,
          required: true,
          errorKey: 'displayNameFr'
        },
        {
          value: this.taskDefinition.displayNameEn,
          required: true,
          errorKey: 'displayNameEn'
        },
        {
          value: this.taskDefinition.serviceGroup,
          required: true,
          errorKey: 'serviceGroup'
        }
      ]
    },
    createTaskDefinition() {
      FormValidator.validateForm(
        this.getTaskDefinitionValidationRules(),
        this.errors
      ).then(() => {
        this.showError = false
        this.taskDefinition.order = 99
        this.taskDefinition.manualdeeplink = false

        ApiService.createTaskDefinition(this.taskDefinition).then(
          result => {
            if (result.status === 200 || result.status === 201) {
              this.$router.push({ name: 'AdminCoredataOverview' })
              //this.taskDefinition = result.data
              //this.toggleSuccess()
              this.scrollUp()
            }
          },
          () => {
            this.showError = true
            this.scrollUp()
          }
        )
      })
    },
    updateTaskDefinition() {
      FormValidator.validateForm(
        this.getTaskDefinitionValidationRules(),
        this.errors
      ).then(() => {
        this.showError = false
        this.taskDefinition.manualdeeplink = false
        ApiService.updateTaskDefinition(this.taskDefinition).then(
          result => {
            if (result.status === 200) {
              this.$router.push({ name: 'AdminCoredataOverview' })
              this.scrollUp()
            }
          },
          error => {
            console.warn(error)
            this.showError = true
            this.scrollUp()
          }
        )
      })
    },
    toggleSuccess() {
      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 2750)
    }
  },
  mounted() {
    // Load task by id.
    if (this.$route.params.id) {
      ApiService.getTaskDefinition(this.$route.params.id).then(res => {
        this.taskDefinition = Object.assign({}, { deeplinkmode: 'servicegroup' }, res.data)
        if (this.taskDefinition.manualdeeplink) { // legacy...
          this.taskDefinition.deeplinkmode = 'manual';
        }
      })
    }
  }
}
</script>

<style scoped></style>
